package one.healthium.base.utils

import kotlinx.browser.document
import one.healthium.base.launcher.PlatformLauncher

internal actual fun appName(platformLauncher: PlatformLauncher): String {
    return document.title
}

internal actual fun appVersion(platformLauncher: PlatformLauncher): String {
    // Read version from meta tag injected by HtmlWebpackPlugin
    return document.querySelector("meta[name='app-version']")?.getAttribute("content") ?: "unknown"
}

internal actual fun appBuildNumber(platformLauncher: PlatformLauncher): String {
    // Read build number from meta tag injected by HtmlWebpackPlugin
    return document.querySelector("meta[name='build-number']")?.getAttribute("content") ?: "0"
}